
import { SkogsvardAtgardsGrupp, SkogsvardAtgardsTyp } from "~app/common/models/constants";

export interface VKAtgardKedjaKopplingCopyGeometryDisplay {
    atgardGuid: string;
    atgardstyp: string;
    status: string;
    checked: boolean;
    isSourceAtgard: boolean;
    isReadonly: boolean;
    beteckning: string;
}

export interface VKAtgardKedjaKopplingCopyGeometryDTO {
    copyAtgardGuid: string;
    copyToAtgarderList: string[];
}

export interface IVKAtgardKedjaKopplingMasshanteringsResponseDTO {
    avtalId: number;
    kontraktId: number;
    kedjaGuid: string;
    kedjaRowVersion: string;
    atgardId?: number;
    atgardGuid: string;
    lopnummer: number;
    rowVersion: string;
    beteckning: string;
    atgardsgrupp: string;
    atgardstyp: string;
    status: string;
    skogsvardStatus: string;
    onskatDatum?: Date;
    skogsvardOnskatDatum?: Date;
    huvudatgard: boolean;
    relativaAr?: number;
    atgardUtford?: boolean;
    isSkogsvard: boolean;
    slutjusteratDatum?: Date;
    produktionGodkandDatum?: Date;
    utfortDatum?: Date;
}

export interface IVKAtgardKedjaInfoResponseDTO {
    avtalId: number;
    kontraktId: number;
    kopplingar: IVKAtgardKedjaKopplingResponseDTO[];
}

export interface IVKAtgardKedjaKopplingResponseDTO {
    avtalId: number;
    kontraktId: number;
    kedjaGuid: string;
    kedjaRowVersion: string;
    atgardId?: number;
    atgardGuid: string;
    lopnummer: number;
    rowVersion: string;
    beteckning: string;
    atgardsgrupp: string;
    atgardstyp: string;
    huvudatgard?: boolean;
    relativaAr?: number;
}

export interface IVKAtgardKedjaKoppling {
    avtalId: number;
    kontraktId: number;
    kedjaGuid: string;
    kedjaRowVersion: string;
    atgardId?: number;
    atgardGuid: string;
    lopnummer: number;
    rowVersion?: string;
    beteckning: string;
    atgardsgrupp: string;
    atgardstyp: string;
    huvudatgard?: boolean;
    relativaAr?: number;
    onskatDatum?: Date;
}

export interface IVKAtgardKedjaKopplingMasshantering {
    atgardsgrupp: string;
    atgardstyp: string;
}

export const isSiktrojning = (koppling: IVKAtgardKedjaKoppling): boolean =>
    koppling.atgardsgrupp === SkogsvardAtgardsGrupp.rojning && (koppling.atgardstyp === SkogsvardAtgardsTyp.siktrojning ||
        koppling.atgardstyp === SkogsvardAtgardsTyp.nsSiktrojning
    );

export const mapKedjekopplingFromMasshantering = (mh: IVKAtgardKedjaKopplingMasshanteringsResponseDTO): IVKAtgardKedjaKoppling => ({
    atgardGuid: mh.atgardGuid,
    atgardsgrupp: mh.atgardsgrupp,
    atgardstyp: mh.atgardstyp,
    avtalId: mh.avtalId,
    atgardId: mh.atgardId,
    beteckning: mh.beteckning,
    kedjaGuid: mh.kedjaGuid,
    kedjaRowVersion: mh.kedjaRowVersion,
    kontraktId: mh.kontraktId,
    lopnummer: mh.lopnummer,
    rowVersion: mh.rowVersion,
    huvudatgard: mh.huvudatgard,
    relativaAr: mh.relativaAr,
    onskatDatum: mh.onskatDatum
});

export const mapKedjaKopplingFromResponseDTO = (dto?: IVKAtgardKedjaKopplingResponseDTO): IVKAtgardKedjaKoppling => ({
    atgardGuid: dto.atgardGuid,
    atgardsgrupp: dto.atgardsgrupp,
    atgardstyp: dto.atgardstyp,
    avtalId: dto.avtalId,
    atgardId: dto.atgardId,
    beteckning: dto.beteckning,
    kedjaGuid: dto.kedjaGuid,
    kedjaRowVersion: dto.kedjaRowVersion,
    kontraktId: dto.kontraktId,
    lopnummer: dto.lopnummer,
    rowVersion: dto.rowVersion,
    relativaAr: dto.relativaAr,
    huvudatgard: dto.huvudatgard
});
